"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyPlaceResponseStruct = void 0;
const superstruct_1 = require("superstruct");
exports.CopyPlaceResponseStruct = (0, superstruct_1.type)({
    placeId: (0, superstruct_1.string)(),
});
//# sourceMappingURL=CopyPlaceResponse.js.map